// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import routeService from '../../services/routeService';
// import inventoryService from '../../services/inventoryService';
// import ShiftService from '../../services/shiftService';
// import ToastService from '../../services/toastService';
// import DashboardService from '../../services/dashboardService';
// import Sidebar from '../Sidebar/Sidebar';
//
// const MOCK_ROUTES = [
//   { id: '1', name: 'Coming Soon' },
// ];
//
// const MOCK_INVENTORIES = [
//   { id: '1', name: 'Coming Soon' },
// ];
//
// const MOCK_MONTHLY_TARGET = {
//   currentSales: 0,
//   targetAmount: 0
// };
//
// const MOCK_TODAY_PROGRESS = {
//   totalSales: 0,
//   cashCollected: 0,
//   creditSales: 0,
//   totalCollections: 0,
//   totalInvoices: 0,
//   visitsMade: 0,
//   totalCustomers: 0
// };
//
// const MOCK_SHIFT_DATA = [
//   { date: 'Coming Soon', route: 'Coming Soon', sales: 0, collections: 0, status: 'Pending' },
// ];
//
// const Dashboard = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [routes, setRoutes] = useState([]);
//   const [inventories, setInventories] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState('');
//   const [selectedInventory, setSelectedInventory] = useState('');
//   const [plannedStartTime, setPlannedStartTime] = useState('08:00');
//   const [plannedEndTime, setPlannedEndTime] = useState('17:00');
//   const [isShiftActive, setIsShiftActive] = useState(false);
//   const [shiftStartTime, setShiftStartTime] = useState(null);
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [loading, setLoading] = useState({
//     routes: false,
//     inventories: false
//   });
//   const [shiftData, setShiftData] = useState([]);
//   const [monthlyTarget, setMonthlyTarget] = useState(MOCK_MONTHLY_TARGET);
//   const [todayProgress, setTodayProgress] = useState(MOCK_TODAY_PROGRESS);
//   const [salesData, setSalesData] = useState(null);
//   const [widgetSalesData, setWidgetSalesData] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [dateFilterLoading, setDateFilterLoading] = useState(false);
//
//   // Pull to refresh states
//   const [refreshing, setRefreshing] = useState(false);
//   const [pullDistance, setPullDistance] = useState(0);
//   const touchStartY = useRef(0);
//   const containerRef = useRef(null);
//
//   useEffect(() => {
//     if (!authService.isAuthenticated()) {
//       ToastService.error('Session expired. Please login again.');
//       navigate('/login');
//       return;
//     }
//
//     const currentUser = authService.getCurrentUser();
//     setUser(currentUser);
//
//     ShiftService.initializeShift();
//
//     const active = ShiftService.isShiftActive();
//     setIsShiftActive(active);
//
//     if (active) {
//       const shift = ShiftService.getCurrentShift();
//       setSelectedRoute(shift.routeId?.toString() || '');
//       setSelectedInventory(shift.inventoryId?.toString() || '');
//       setShiftStartTime(shift.startTime);
//
//       const plannedShift = JSON.parse(localStorage.getItem('plannedShift')) || { start: '08:00', end: '17:00' };
//       setPlannedStartTime(plannedShift.start);
//       setPlannedEndTime(plannedShift.end);
//     }
//
//     fetchData();
//     fetchWidgetSalesData();
//     fetchSalesData();
//     loadShiftData();
//   }, [navigate]);
//
//   // Pull to refresh handlers
//   const handleTouchStart = (e) => {
//     if (containerRef.current && containerRef.current.scrollTop === 0) {
//       touchStartY.current = e.touches[0].clientY;
//     }
//   };
//
//   const handleTouchMove = (e) => {
//     if (refreshing) return;
//
//     const touchY = e.touches[0].clientY;
//     const pull = touchY - touchStartY.current;
//
//     if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
//       e.preventDefault();
//       setPullDistance(Math.min(pull, 100));
//     }
//   };
//
//   const handleTouchEnd = () => {
//     if (pullDistance > 60) {
//       handleRefresh();
//     }
//     setPullDistance(0);
//   };
//
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     try {
//       await Promise.all([
//         fetchData(),
//         fetchWidgetSalesData(),
//         fetchSalesData(selectedDate),
//       ]);
//       ToastService.success('Dashboard refreshed', 1500);
//     } catch (error) {
//       ToastService.error('Refresh failed');
//     } finally {
//       setTimeout(() => setRefreshing(false), 500);
//     }
//   };
//
//   const fetchWidgetSalesData = async () => {
//     try {
//       const data = await DashboardService.getSalesDataMonthToDate();
//       setWidgetSalesData(data);
//     } catch (error) {
//       console.error('Failed to fetch widget sales data:', error);
//       setWidgetSalesData({
//         totals: {
//           CASH: { totalAmount: "0", count: 0 },
//           CHEQUE: { totalAmount: "0", count: 0 },
//           COLLECTION: { totalAmount: 0, count: 0 },
//           ALL: { totalAmount: "0", count: 0 }
//         },
//         creditsSummary: {
//           totalAmount: 0,
//           totalCredits: 0
//         }
//       });
//     }
//   };
//
//   const fetchData = async () => {
//     try {
//       setLoading(prev => ({ ...prev, routes: true }));
//
//       try {
//         const routesResponse = await routeService.getAvailableRoutes();
//         if (routesResponse.success) {
//           setRoutes(routesResponse.data.map(route => ({
//             id: route.id.toString(),
//             name: route.name
//           })));
//         } else {
//           setRoutes(MOCK_ROUTES);
//         }
//       } catch (error) {
//         console.warn('Using mock routes:', error.message);
//         setRoutes(MOCK_ROUTES);
//       }
//
//       setLoading(prev => ({ ...prev, inventories: true }));
//
//       try {
//         const inventoriesResponse = await inventoryService.getAvailableInventories();
//         if (inventoriesResponse.success) {
//           setInventories(inventoriesResponse.data.map(inv => ({
//             id: inv.id.toString(),
//             name: inv.name
//           })));
//         } else {
//           setInventories(MOCK_INVENTORIES);
//         }
//       } catch (error) {
//         console.warn('Using mock inventories:', error.message);
//         setInventories(MOCK_INVENTORIES);
//       }
//     } catch (error) {
//       ToastService.error('Failed to load dashboard data');
//     } finally {
//       setLoading({ routes: false, inventories: false });
//     }
//   };
//
//   const fetchSalesData = async (date = new Date()) => {
//     try {
//       setDateFilterLoading(true);
//       const data = await DashboardService.getSalesData(date);
//       setSalesData(data);
//     } catch (error) {
//       console.error('Error fetching sales data:', error);
//       ToastService.error('Failed to load sales data');
//     } finally {
//       setDateFilterLoading(false);
//     }
//   };
//
//   const loadShiftData = () => {
//     setShiftData(MOCK_SHIFT_DATA);
//     setMonthlyTarget(MOCK_MONTHLY_TARGET);
//     setTodayProgress(MOCK_TODAY_PROGRESS);
//   };
//
//   const handleStartShift = () => {
//     if (!selectedRoute || !selectedInventory) {
//       ToastService.error('Please select both Lorry/Route and Warehouse/Area first!', 'error', 3000);
//       return;
//     }
//
//     const routeId = selectedRoute;
//     const inventoryId = selectedInventory;
//
//     const shift = ShiftService.startShift(routeId, inventoryId);
//
//     setIsShiftActive(true);
//     setShiftStartTime(shift.startTime);
//
//     const plannedShift = {
//       start: plannedStartTime,
//       end: plannedEndTime
//     };
//     localStorage.setItem('plannedShift', JSON.stringify(plannedShift));
//
//     ToastService.success(`Shift Started! ${getCurrentRouteName()}`, 'success', 3500);
//   };
//
//   const handleEndShift = () => {
//     if (window.confirm("End your shift now?")) {
//       const endTime = new Date();
//       const start = new Date(shiftStartTime);
//       const durationMs = endTime - start;
//       const hours = Math.floor(durationMs / 3600000);
//       const minutes = Math.floor((durationMs % 3600000) / 60000);
//
//       ShiftService.endShift();
//
//       setIsShiftActive(false);
//       setSelectedRoute('');
//       setSelectedInventory('');
//       setShiftStartTime(null);
//
//       ToastService.success(`Shift Ended! ${hours}h ${minutes}m`, 'info', 3000);
//
//       loadShiftData();
//     }
//   };
//
//   const handleMakeSale = () => {
//     if (!isShiftActive) {
//       ToastService.error('Please start your shift first!', 'error', 3000);
//       return;
//     }
//     navigate('/create-sale');
//   };
//
//   const handlePlannedTimeChange = (type, value) => {
//     if (!isShiftActive) {
//       if (type === 'start') {
//         setPlannedStartTime(value);
//       } else {
//         setPlannedEndTime(value);
//       }
//
//       const plannedShift = {
//         start: type === 'start' ? value : plannedStartTime,
//         end: type === 'end' ? value : plannedEndTime
//       };
//       localStorage.setItem('plannedShift', JSON.stringify(plannedShift));
//       ToastService.success('Planned shift time saved', 'success', 2000);
//     }
//   };
//
//   const getCurrentRouteName = () => {
//     const route = routes.find(r => r.id === selectedRoute);
//     return route ? route.name : 'Not selected';
//   };
//
//   const getCurrentInventoryName = () => {
//     const inventory = inventories.find(i => i.id === selectedInventory);
//     return inventory ? inventory.name : 'Not selected';
//   };
//
//   const formatCurrency = (amount) => {
//     const num = Number(amount);
//     return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };
//
//   const getGreeting = () => {
//     const now = new Date();
//     const hour = now.getHours();
//     if (hour < 12) return 'Good Morning';
//     if (hour < 18) return 'Good Afternoon';
//     return 'Good Evening';
//   };
//
//   const handleDateChange = (e) => {
//     const newDate = new Date(e.target.value);
//     setSelectedDate(newDate);
//     fetchSalesData(newDate);
//   };
//
//   const handleTodayClick = () => {
//     const today = new Date();
//     setSelectedDate(today);
//     fetchSalesData(today);
//   };
//
//   const formatDate = () => {
//     const now = new Date();
//     return now.toLocaleDateString('en-US', {
//       weekday: 'long',
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };
//
//   const getProgressPercentage = () => {
//     const percentage = Math.min(100, (monthlyTarget.currentSales / monthlyTarget.targetAmount) * 100);
//     return percentage.toFixed(1);
//   };
//
//   const getShiftDuration = () => {
//     if (!shiftStartTime) return '0m';
//
//     const start = new Date(shiftStartTime);
//     const now = new Date();
//     const durationMs = now - start;
//
//     const hours = Math.floor(durationMs / 3600000);
//     const minutes = Math.floor((durationMs % 3600000) / 60000);
//
//     if (hours > 0) {
//       return `${hours}h ${minutes}m`;
//     }
//     return `${minutes}m`;
//   };
//
//   const getActualStartTimeDisplay = () => {
//     if (!shiftStartTime) return 'Not Started';
//     const date = new Date(shiftStartTime);
//     return `Started: ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
//   };
//
//   const handleRouteChange = (e) => {
//     const value = e.target.value;
//     setSelectedRoute(value);
//     if (value && !isShiftActive) {
//       const route = routes.find(r => r.id === value);
//       ToastService.info(`Route: ${route?.name}`, 'info', 2000);
//     }
//   };
//
//   const handleInventoryChange = (e) => {
//     const value = e.target.value;
//     setSelectedInventory(value);
//     if (value && !isShiftActive) {
//       const inventory = inventories.find(i => i.id === value);
//       ToastService.info(`Area: ${inventory?.name}`, 'info', 2000);
//     }
//   };
//
//   return (
//     <div
//       ref={containerRef}
//       className="min-h-screen bg-gray-50 overflow-y-auto"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />
//
//       {showSidebar && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
//           onClick={() => setShowSidebar(false)}
//         />
//       )}
//
//       {/* Pull to Refresh Indicator */}
//       {pullDistance > 0 && (
//         <div
//           className="fixed top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-50"
//           style={{
//             transform: `translateY(${pullDistance}px)`,
//             opacity: pullDistance / 100
//           }}
//         >
//           <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
//             <svg
//               className="w-5 h-5 text-blue-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//               />
//             </svg>
//           </div>
//         </div>
//       )}
//
//       {/* Header */}
//       <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
//         <div className="px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center gap-3 sm:gap-4">
//               <button
//                 className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
//                 onClick={() => setShowSidebar(true)}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//               <h1 className="text-lg sm:text-xl font-semibold text-white">Theresa Products</h1>
//             </div>
//
//             <div className="flex items-center gap-2 sm:gap-3">
//               <span className={`px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium ${
//                 isShiftActive
//                   ? 'bg-green-400 text-green-900'
//                   : 'bg-white/20 text-white'
//               }`}>
//                 Shift: {isShiftActive ? 'ON' : 'OFF'}
//               </span>
//               {/* <button
//                 className="w-9 h-9 sm:w-10 sm:h-10 rounded-full overflow-hidden hover:ring-2 hover:ring-white transition-all border-2 border-white/30"
//                 onClick={() => navigate('/profile')}
//               >
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
//                   alt="Profile"
//                   className="w-full h-full object-cover"
//                 />
//               </button> */}
//             </div>
//           </div>
//         </div>
//       </header>
//
//       {/* Main Content */}
//       <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
//
//         {/* Greeting Section */}
//         <div className="mb-6 sm:mb-8">
//           <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
//             {getGreeting()}, {user?.firstName || 'User'}!
//           </h2>
//           <p className="text-sm sm:text-base text-gray-600 mt-1">{formatDate()}</p>
//         </div>
//
//         {/* Sales Overview Widget */}
//         <div
//           className="rounded-2xl shadow-lg p-5 sm:p-6 mb-6 relative overflow-hidden"
//           style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//         >
//           <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
//             <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//             </svg>
//             Sales Overview (Month-to-Date)
//           </h3>
//
//           <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
//             {/* Total Sales */}
//             <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
//               <div className="text-xs font-medium text-blue-700 mb-1">Total Sales</div>
//               <div className="text-lg sm:text-xl font-bold text-blue-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(
//                   ((parseFloat(widgetSalesData.totals?.ALL?.totalAmount || 0) -
//                   parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)) +
//                    parseFloat(widgetSalesData.creditsSummary?.totalAmount || 0)
//                   ).toString()
//                 )}` : '0'}
//               </div>
//             </div>
//
//             {/* Sales Without Credit */}
//             <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 border border-purple-200">
//               <div className="text-xs font-medium text-purple-700 mb-1">Sales (No Credit)</div>
//               <div className="text-lg sm:text-xl font-bold text-purple-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(
//                   (parseFloat(widgetSalesData.totals?.ALL?.totalAmount || 0) -
//                    parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)
//                   ).toString()
//                 )}` : '0'}
//               </div>
//             </div>
//
//             {/* Cash */}
//             <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 border border-green-200">
//               <div className="text-xs font-medium text-green-700 mb-1">Cash</div>
//               <div className="text-lg sm:text-xl font-bold text-green-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.CASH?.totalAmount || 0)}` : '0'}
//               </div>
//             </div>
//
//             {/* Cheque */}
//             <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-4 border border-yellow-200">
//               <div className="text-xs font-medium text-yellow-700 mb-1">Cheque</div>
//               <div className="text-lg sm:text-xl font-bold text-yellow-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.CHEQUE?.totalAmount || 0)}` : '0'}
//               </div>
//             </div>
//
//             {/* Credit */}
//             <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-4 border border-orange-200">
//               <div className="text-xs font-medium text-orange-700 mb-1">Credit</div>
//               <div className="text-lg sm:text-xl font-bold text-orange-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.creditsSummary?.totalAmount || 0)}` : '0'}
//               </div>
//             </div>
//
//             {/* Collections */}
//             <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-4 border border-teal-200">
//               <div className="text-xs font-medium text-teal-700 mb-1">Collections</div>
//               <div className="text-lg sm:text-xl font-bold text-teal-900">
//                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)}` : '0'}
//               </div>
//             </div>
//           </div>
//         </div>
//
//         {/* Shift Management Card */}
//         <div
//           className="rounded-2xl shadow-lg p-5 sm:p-6 mb-6"
//           style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//         >
//           <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
//             <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             My Shift Today
//           </h3>
//
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
//             {/* Lorry/Route */}
//             <div>
//               <label className="block text-sm font-medium text-white/90 mb-2">
//                 Lorry / Route
//               </label>
//               <select
//                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                 value={selectedRoute}
//                 onChange={handleRouteChange}
//                 disabled={isShiftActive || loading.routes}
//               >
//                 <option value="" disabled>Select Lorry/Route</option>
//                 {routes.map(route => (
//                   <option key={route.id} value={route.id}>
//                     {route.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//
//             {/* Warehouse/Area */}
//             <div>
//               <label className="block text-sm font-medium text-white/90 mb-2">
//                 Warehouse / Area
//               </label>
//               <select
//                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                 value={selectedInventory}
//                 onChange={handleInventoryChange}
//                 disabled={isShiftActive || loading.inventories}
//               >
//                 <option value="" disabled>Select Warehouse/Area</option>
//                 {inventories.map(inventory => (
//                   <option key={inventory.id} value={inventory.id}>
//                     {inventory.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//
//             {/* Planned Start Time */}
//             <div>
//               <label className="block text-sm font-medium text-white/90 mb-2">
//                 Planned Start Time
//               </label>
//               <input
//                 type="time"
//                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                 value={plannedStartTime}
//                 onChange={(e) => handlePlannedTimeChange('start', e.target.value)}
//                 disabled={isShiftActive}
//               />
//             </div>
//
//             {/* Planned End Time */}
//             <div>
//               <label className="block text-sm font-medium text-white/90 mb-2">
//                 Planned End Time
//               </label>
//               <input
//                 type="time"
//                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                 value={plannedEndTime}
//                 onChange={(e) => handlePlannedTimeChange('end', e.target.value)}
//                 disabled={isShiftActive}
//               />
//             </div>
//
//             {/* Actual Start Time */}
//             <div>
//               <label className="block text-sm font-medium text-white/90 mb-2">
//                 Actual Start Time
//               </label>
//               <input
//                 type="text"
//                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/70 text-sm text-gray-700 cursor-not-allowed"
//                 readOnly
//                 value={getActualStartTimeDisplay()}
//               />
//             </div>
//           </div>
//
//           <button
//             className={`w-full sm:w-auto px-8 py-3 rounded-lg font-semibold transition-all transform hover:scale-105 active:scale-95 shadow-lg ${
//               isShiftActive
//                 ? 'bg-white text-red-600 hover:bg-red-50'
//                 : 'bg-white text-green-600 hover:bg-green-50'
//             }`}
//             onClick={isShiftActive ? handleEndShift : handleStartShift}
//           >
//             {isShiftActive ? 'End Shift' : 'Start Shift'}
//           </button>
//         </div>
//
//         {/* Make Sale Button */}
//         <button
//           className={`w-full mb-6 px-6 py-4 rounded-xl font-bold text-lg transition-all transform shadow-lg ${
//             isShiftActive
//               ? 'text-white hover:scale-[1.02] active:scale-95'
//               : 'bg-gray-400 text-white cursor-not-allowed'
//           }`}
//           style={isShiftActive ? { background: 'linear-gradient(135deg, #0613cc, #0613cc)' } : {}}
//           onClick={handleMakeSale}
//           disabled={!isShiftActive}
//         >
//           {isShiftActive ? (
//             <span className="flex items-center justify-center gap-3">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
//               </svg>
//               Make New Sale
//             </span>
//           ) : (
//             <span className="flex items-center justify-center gap-3">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//               </svg>
//               Start your Shift First!
//             </span>
//           )}
//         </button>
//
//         {/* Today's Progress Card */}
//         <div
//           className="rounded-2xl shadow-lg p-5 sm:p-6"
//           style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//         >
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
//             <h3 className="text-lg font-semibold text-white flex items-center gap-2">
//               <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               {selectedDate.toDateString() === new Date().toDateString()
//                 ? "Today's Progress"
//                 : `Progress for ${selectedDate.toLocaleDateString()}`}
//             </h3>
//
//             <div className="flex items-center gap-2">
//               <input
//                 type="date"
//                 value={selectedDate.toISOString().split('T')[0]}
//                 onChange={handleDateChange}
//                 className="px-3 py-2 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white disabled:opacity-60"
//                 disabled={dateFilterLoading || !isShiftActive}
//               />
//               <button
//                 onClick={handleTodayClick}
//                 className="px-4 py-2 rounded-lg bg-white text-[#1565ff] text-sm font-medium hover:bg-white/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//                 disabled={dateFilterLoading}
//               >
//                 Today
//               </button>
//             </div>
//           </div>
//
//           {dateFilterLoading ? (
//             <div className="flex items-center justify-center py-12">
//               <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white"></div>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//               {/* Total Sales */}
//               <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 border border-blue-200">
//                 <div className="text-sm font-medium text-blue-700 mb-2">Total Sales</div>
//                 <div className="text-2xl font-bold text-blue-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(
//                     ((parseFloat(salesData.totals?.ALL?.totalAmount || 0) -
//                       parseFloat(salesData.totals?.COLLECTION?.totalAmount || 0)) +
//                      parseFloat(salesData.creditsSummary?.totalAmount || 0)
//                     ).toString()
//                   )}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-blue-600">
//                     {salesData.totals?.ALL?.count - 2 || 0} cash + {salesData.totals?.CHEQUE?.count || 0} cheque + {salesData.creditsSummary?.totalCredits || 0} credit
//                   </div>
//                 )}
//               </div>
//
//               {/* Total Sales Without Credits */}
//               <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-5 border border-purple-200">
//                 <div className="text-sm font-medium text-purple-700 mb-2">Sales (No Credit)</div>
//                 <div className="text-2xl font-bold text-purple-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(
//                     (parseFloat(salesData.totals?.ALL?.totalAmount || 0) -
//                      parseFloat(salesData.totals?.COLLECTION?.totalAmount || 0)
//                     ).toString()
//                   )}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-purple-600">
//                     {salesData.totals?.ALL?.count || 0} transactions
//                   </div>
//                 )}
//               </div>
//
//               {/* Cash Collected */}
//               <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-5 border border-green-200">
//                 <div className="text-sm font-medium text-green-700 mb-2">Cash Collected</div>
//                 <div className="text-2xl font-bold text-green-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CASH?.totalAmount || 0)}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-green-600">
//                     {salesData.totals?.CASH?.count || 0} cash transactions
//                   </div>
//                 )}
//               </div>
//
//               {/* Cheque Sales */}
//               <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-5 border border-yellow-200">
//                 <div className="text-sm font-medium text-yellow-700 mb-2">Cheque Sales</div>
//                 <div className="text-2xl font-bold text-yellow-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CHEQUE?.totalAmount || 0)}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-yellow-600">
//                     {salesData.totals?.CHEQUE?.count || 0} cheque transactions
//                   </div>
//                 )}
//               </div>
//
//               {/* Credit Sales */}
//               <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-5 border border-orange-200">
//                 <div className="text-sm font-medium text-orange-700 mb-2">Credit Sales</div>
//                 <div className="text-2xl font-bold text-orange-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.creditsSummary?.totalAmount || 0)}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-orange-600">
//                     {salesData.creditsSummary?.totalCredits || 0} credit accounts
//                   </div>
//                 )}
//               </div>
//
//               {/* Collections */}
//               <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-5 border border-teal-200">
//                 <div className="text-sm font-medium text-teal-700 mb-2">Total Collections</div>
//                 <div className="text-2xl font-bold text-teal-900 mb-1">
//                   {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.COLLECTION?.totalAmount || 0)}` : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-teal-600">
//                     {salesData.totals?.COLLECTION?.count || 0} collections
//                   </div>
//                 )}
//               </div>
//
//               {/* Total Invoices */}
//               <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-5 border border-indigo-200">
//                 <div className="text-sm font-medium text-indigo-700 mb-2">Total Invoices</div>
//                 <div className="text-2xl font-bold text-indigo-900 mb-1">
//                   {salesData ? salesData.totals?.ALL?.count || 0 : 'Coming Soon'}
//                 </div>
//                 {salesData && (
//                   <div className="text-xs text-indigo-600">
//                     All transaction types
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </main>
//     </div>
//   );
// };
//
// export default Dashboard;

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import routeService from '../../services/routeService';
// import inventoryService from '../../services/inventoryService';
// import ShiftService from '../../services/shiftService';
// import ToastService from '../../services/toastService';
// import DashboardService from '../../services/dashboardService';
// import Sidebar from '../Sidebar/Sidebar';

// const MOCK_ROUTES = [
//     { id: '1', name: 'Coming Soon' },
// ];

// const MOCK_INVENTORIES = [
//     { id: '1', name: 'Coming Soon' },
// ];

// const MOCK_MONTHLY_TARGET = {
//     currentSales: 0,
//     targetAmount: 0
// };

// const MOCK_TODAY_PROGRESS = {
//     totalSales: 0,
//     cashCollected: 0,
//     creditSales: 0,
//     totalCollections: 0,
//     totalInvoices: 0,
//     visitsMade: 0,
//     totalCustomers: 0
// };

// const MOCK_SHIFT_DATA = [
//     { date: 'Coming Soon', route: 'Coming Soon', sales: 0, collections: 0, status: 'Pending' },
// ];

// const Dashboard = () => {
//     const navigate = useNavigate();
//     const [user, setUser] = useState(null);
//     const [routes, setRoutes] = useState([]);
//     const [inventories, setInventories] = useState([]);
//     const [selectedRoute, setSelectedRoute] = useState('');
//     const [selectedInventory, setSelectedInventory] = useState('');
//     const [plannedStartTime, setPlannedStartTime] = useState('08:00');
//     const [plannedEndTime, setPlannedEndTime] = useState('17:00');
//     const [isShiftActive, setIsShiftActive] = useState(false);
//     const [shiftStartTime, setShiftStartTime] = useState(null);
//     const [showSidebar, setShowSidebar] = useState(false);
//     const [loading, setLoading] = useState({
//         routes: false,
//         inventories: false
//     });
//     const [shiftData, setShiftData] = useState([]);
//     const [monthlyTarget, setMonthlyTarget] = useState(MOCK_MONTHLY_TARGET);
//     const [todayProgress, setTodayProgress] = useState(MOCK_TODAY_PROGRESS);
//     const [salesData, setSalesData] = useState(null);
//     const [widgetSalesData, setWidgetSalesData] = useState(null);
//     const [selectedDate, setSelectedDate] = useState(new Date());
//     const [dateFilterLoading, setDateFilterLoading] = useState(false);

//     useEffect(() => {
//         if (!authService.isAuthenticated()) {
//             ToastService.error('Session expired. Please login again.');
//             navigate('/login');
//             return;
//         }

//         const currentUser = authService.getCurrentUser();
//         setUser(currentUser);

//         ShiftService.initializeShift();

//         const active = ShiftService.isShiftActive();
//         setIsShiftActive(active);

//         if (active) {
//             const shift = ShiftService.getCurrentShift();
//             setSelectedRoute(shift.routeId?.toString() || '');
//             setSelectedInventory(shift.inventoryId?.toString() || '');
//             setShiftStartTime(shift.startTime);

//             const plannedShift = JSON.parse(localStorage.getItem('plannedShift')) || { start: '08:00', end: '17:00' };
//             setPlannedStartTime(plannedShift.start);
//             setPlannedEndTime(plannedShift.end);
//         }

//         fetchData();
//         fetchWidgetSalesData();
//         fetchSalesData();
//         loadShiftData();
//     }, [navigate]);

//     const fetchWidgetSalesData = async () => {
//         try {
//             const data = await DashboardService.getSalesDataMonthToDate();
//             setWidgetSalesData(data);
//         } catch (error) {
//             console.error('Failed to fetch widget sales data:', error);
//             setWidgetSalesData({
//                 totals: {
//                     CASH: { totalAmount: "0", count: 0 },
//                     CHEQUE: { totalAmount: "0", count: 0 },
//                     COLLECTION: { totalAmount: 0, count: 0 },
//                     ALL: { totalAmount: "0", count: 0 }
//                 },
//                 creditsSummary: {
//                     totalAmount: 0,
//                     totalCredits: 0
//                 }
//             });
//         }
//     };

//     const fetchData = async () => {
//         try {
//             setLoading(prev => ({ ...prev, routes: true }));

//             try {
//                 const routesResponse = await routeService.getAvailableRoutes();
//                 if (routesResponse.success) {
//                     setRoutes(routesResponse.data.map(route => ({
//                         id: route.id.toString(),
//                         name: route.name
//                     })));
//                 } else {
//                     setRoutes(MOCK_ROUTES);
//                 }
//             } catch (error) {
//                 console.warn('Using mock routes:', error.message);
//                 setRoutes(MOCK_ROUTES);
//             }

//             setLoading(prev => ({ ...prev, inventories: true }));

//             try {
//                 const inventoriesResponse = await inventoryService.getAvailableInventories();
//                 if (inventoriesResponse.success) {
//                     setInventories(inventoriesResponse.data.map(inv => ({
//                         id: inv.id.toString(),
//                         name: inv.name
//                     })));
//                 } else {
//                     setInventories(MOCK_INVENTORIES);
//                 }
//             } catch (error) {
//                 console.warn('Using mock inventories:', error.message);
//                 setInventories(MOCK_INVENTORIES);
//             }
//         } catch (error) {
//             ToastService.error('Failed to load dashboard data');
//         } finally {
//             setLoading({ routes: false, inventories: false });
//         }
//     };

//     const fetchSalesData = async (date = new Date()) => {
//         try {
//             setDateFilterLoading(true);
//             const data = await DashboardService.getSalesData(date);
//             setSalesData(data);
//         } catch (error) {
//             console.error('Error fetching sales data:', error);
//             ToastService.error('Failed to load sales data');
//         } finally {
//             setDateFilterLoading(false);
//         }
//     };

//     const loadShiftData = () => {
//         setShiftData(MOCK_SHIFT_DATA);
//         setMonthlyTarget(MOCK_MONTHLY_TARGET);
//         setTodayProgress(MOCK_TODAY_PROGRESS);
//     };

//     const handleStartShift = () => {
//         if (!selectedRoute || !selectedInventory) {
//             ToastService.error('Please select both Lorry/Route and Warehouse/Area first!', 'error', 3000);
//             return;
//         }

//         const routeId = selectedRoute;
//         const inventoryId = selectedInventory;

//         const shift = ShiftService.startShift(routeId, inventoryId);

//         setIsShiftActive(true);
//         setShiftStartTime(shift.startTime);

//         const plannedShift = {
//             start: plannedStartTime,
//             end: plannedEndTime
//         };
//         localStorage.setItem('plannedShift', JSON.stringify(plannedShift));

//         ToastService.success(`Shift Started! ${getCurrentRouteName()}`, 'success', 3500);
//     };

//     const handleEndShift = () => {
//         if (window.confirm("End your shift now?")) {
//             const endTime = new Date();
//             const start = new Date(shiftStartTime);
//             const durationMs = endTime - start;
//             const hours = Math.floor(durationMs / 3600000);
//             const minutes = Math.floor((durationMs % 3600000) / 60000);

//             ShiftService.endShift();

//             setIsShiftActive(false);
//             setSelectedRoute('');
//             setSelectedInventory('');
//             setShiftStartTime(null);

//             ToastService.success(`Shift Ended! ${hours}h ${minutes}m`, 'info', 3000);

//             loadShiftData();
//         }
//     };

//     const handleMakeSale = () => {
//         if (!isShiftActive) {
//             ToastService.error('Please start your shift first!', 'error', 3000);
//             return;
//         }
//         navigate('/create-sale');
//     };

//     const handlePlannedTimeChange = (type, value) => {
//         if (!isShiftActive) {
//             if (type === 'start') {
//                 setPlannedStartTime(value);
//             } else {
//                 setPlannedEndTime(value);
//             }

//             const plannedShift = {
//                 start: type === 'start' ? value : plannedStartTime,
//                 end: type === 'end' ? value : plannedEndTime
//             };
//             localStorage.setItem('plannedShift', JSON.stringify(plannedShift));
//             ToastService.success('Planned shift time saved', 'success', 2000);
//         }
//     };

//     const getCurrentRouteName = () => {
//         const route = routes.find(r => r.id === selectedRoute);
//         return route ? route.name : 'Not selected';
//     };

//     const getCurrentInventoryName = () => {
//         const inventory = inventories.find(i => i.id === selectedInventory);
//         return inventory ? inventory.name : 'Not selected';
//     };

//     const formatCurrency = (amount) => {
//         const num = Number(amount);
//         return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//     };

//     const getGreeting = () => {
//         const now = new Date();
//         const hour = now.getHours();
//         if (hour < 12) return 'Good Morning';
//         if (hour < 18) return 'Good Afternoon';
//         return 'Good Evening';
//     };

//     const handleDateChange = (e) => {
//         const newDate = new Date(e.target.value);
//         setSelectedDate(newDate);
//         fetchSalesData(newDate);
//     };

//     const handleTodayClick = () => {
//         const today = new Date();
//         setSelectedDate(today);
//         fetchSalesData(today);
//     };

//     const formatDate = () => {
//         const now = new Date();
//         return now.toLocaleDateString('en-US', {
//             weekday: 'long',
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//         });
//     };

//     const getProgressPercentage = () => {
//         const percentage = Math.min(100, (monthlyTarget.currentSales / monthlyTarget.targetAmount) * 100);
//         return percentage.toFixed(1);
//     };

//     const getShiftDuration = () => {
//         if (!shiftStartTime) return '0m';

//         const start = new Date(shiftStartTime);
//         const now = new Date();
//         const durationMs = now - start;

//         const hours = Math.floor(durationMs / 3600000);
//         const minutes = Math.floor((durationMs % 3600000) / 60000);

//         if (hours > 0) {
//             return `${hours}h ${minutes}m`;
//         }
//         return `${minutes}m`;
//     };

//     const getActualStartTimeDisplay = () => {
//         if (!shiftStartTime) return 'Not Started';
//         const date = new Date(shiftStartTime);
//         return `Started: ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
//     };

//     const handleRouteChange = (e) => {
//         const value = e.target.value;
//         setSelectedRoute(value);
//         if (value && !isShiftActive) {
//             const route = routes.find(r => r.id === value);
//             ToastService.info(`Route: ${route?.name}`, 'info', 2000);
//         }
//     };

//     const handleInventoryChange = (e) => {
//         const value = e.target.value;
//         setSelectedInventory(value);
//         if (value && !isShiftActive) {
//             const inventory = inventories.find(i => i.id === value);
//             ToastService.info(`Area: ${inventory?.name}`, 'info', 2000);
//         }
//     };

//     return (
//         <div
//             className="min-h-screen bg-gray-50 overflow-y-auto"
//         >
//             <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />

//             {showSidebar && (
//                 <div
//                     className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
//                     onClick={() => setShowSidebar(false)}
//                 />
//             )}

//             {/* Header */}
//             <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
//                 <div className="px-4 sm:px-6 lg:px-8">
//                     <div className="flex items-center justify-between h-16">
//                         <div className="flex items-center gap-3 sm:gap-4">
//                             <button
//                                 className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
//                                 onClick={() => setShowSidebar(true)}
//                             >
//                                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                                 </svg>
//                             </button>
//                             <h1 className="text-lg sm:text-xl font-semibold text-white">Sales App Lite</h1>
//                         </div>

//                         <div className="flex items-center gap-2 sm:gap-3">
//               <span className={`px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium ${
//                   isShiftActive
//                       ? 'bg-green-400 text-green-900'
//                       : 'bg-white/20 text-white'
//               }`}>
//                 Shift: {isShiftActive ? 'ON' : 'OFF'}
//               </span>
//                             {/* <button
//                 className="w-9 h-9 sm:w-10 sm:h-10 rounded-full overflow-hidden hover:ring-2 hover:ring-white transition-all border-2 border-white/30"
//                 onClick={() => navigate('/profile')}
//               >
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
//                   alt="Profile"
//                   className="w-full h-full object-cover"
//                 />
//               </button> */}
//                         </div>
//                     </div>
//                 </div>
//             </header>

//             {/* Main Content */}
//             <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">

//                 {/* Greeting Section */}
//                 <div className="mb-6 sm:mb-8">
//                     <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
//                         {getGreeting()}, {user?.firstName || 'User'}!
//                     </h2>
//                     <p className="text-sm sm:text-base text-gray-600 mt-1">{formatDate()}</p>
//                 </div>

//                 {/* Sales Overview Widget */}
//                 <div
//                     className="rounded-2xl shadow-lg p-5 sm:p-6 mb-6 relative overflow-hidden"
//                     style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                 >
//                     <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
//                         <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                         </svg>
//                         Sales Overview (Month-to-Date)
//                     </h3>

//                     <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
//                         {/* Total Sales */}
//                         <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
//                             <div className="text-xs font-medium text-blue-700 mb-1">Total Sales</div>
//                             <div className="text-lg sm:text-xl font-bold text-blue-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(
//                                     ((parseFloat(widgetSalesData.totals?.ALL?.totalAmount || 0) -
//                                             parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)) +
//                                         parseFloat(widgetSalesData.creditsSummary?.totalAmount || 0)
//                                     ).toString()
//                                 )}` : '0'}
//                             </div>
//                         </div>

//                         {/* Sales Without Credit */}
//                         <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 border border-purple-200">
//                             <div className="text-xs font-medium text-purple-700 mb-1">Sales (No Credit)</div>
//                             <div className="text-lg sm:text-xl font-bold text-purple-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(
//                                     (parseFloat(widgetSalesData.totals?.ALL?.totalAmount || 0) -
//                                         parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)
//                                     ).toString()
//                                 )}` : '0'}
//                             </div>
//                         </div>

//                         {/* Cash */}
//                         <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-4 border border-green-200">
//                             <div className="text-xs font-medium text-green-700 mb-1">Cash</div>
//                             <div className="text-lg sm:text-xl font-bold text-green-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.CASH?.totalAmount || 0)}` : '0'}
//                             </div>
//                         </div>

//                         {/* Cheque */}
//                         <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-4 border border-yellow-200">
//                             <div className="text-xs font-medium text-yellow-700 mb-1">Cheque</div>
//                             <div className="text-lg sm:text-xl font-bold text-yellow-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.CHEQUE?.totalAmount || 0)}` : '0'}
//                             </div>
//                         </div>

//                         {/* Credit */}
//                         <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-4 border border-orange-200">
//                             <div className="text-xs font-medium text-orange-700 mb-1">Credit</div>
//                             <div className="text-lg sm:text-xl font-bold text-orange-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.creditsSummary?.totalAmount || 0)}` : '0'}
//                             </div>
//                         </div>

//                         {/* Collections */}
//                         <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-4 border border-teal-200">
//                             <div className="text-xs font-medium text-teal-700 mb-1">Collections</div>
//                             <div className="text-lg sm:text-xl font-bold text-teal-900">
//                                 {widgetSalesData ? `Rs. ${DashboardService.formatCurrency(widgetSalesData.totals?.COLLECTION?.totalAmount || 0)}` : '0'}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Shift Management Card */}
//                 <div
//                     className="rounded-2xl shadow-lg p-5 sm:p-6 mb-6"
//                     style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                 >
//                     <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
//                         <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                         </svg>
//                         My Shift Today
//                     </h3>

//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
//                         {/* Lorry/Route */}
//                         <div>
//                             <label className="block text-sm font-medium text-white/90 mb-2">
//                                 Lorry / Route
//                             </label>
//                             <select
//                                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                                 value={selectedRoute}
//                                 onChange={handleRouteChange}
//                                 disabled={isShiftActive || loading.routes}
//                             >
//                                 <option value="" disabled>Select Lorry/Route</option>
//                                 {routes.map(route => (
//                                     <option key={route.id} value={route.id}>
//                                         {route.name}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Warehouse/Area */}
//                         <div>
//                             <label className="block text-sm font-medium text-white/90 mb-2">
//                                 Warehouse / Area
//                             </label>
//                             <select
//                                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                                 value={selectedInventory}
//                                 onChange={handleInventoryChange}
//                                 disabled={isShiftActive || loading.inventories}
//                             >
//                                 <option value="" disabled>Select Warehouse/Area</option>
//                                 {inventories.map(inventory => (
//                                     <option key={inventory.id} value={inventory.id}>
//                                         {inventory.name}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Planned Start Time */}
//                         <div>
//                             <label className="block text-sm font-medium text-white/90 mb-2">
//                                 Planned Start Time
//                             </label>
//                             <input
//                                 type="time"
//                                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                                 value={plannedStartTime}
//                                 onChange={(e) => handlePlannedTimeChange('start', e.target.value)}
//                                 disabled={isShiftActive}
//                             />
//                         </div>

//                         {/* Planned End Time */}
//                         <div>
//                             <label className="block text-sm font-medium text-white/90 mb-2">
//                                 Planned End Time
//                             </label>
//                             <input
//                                 type="time"
//                                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                                 value={plannedEndTime}
//                                 onChange={(e) => handlePlannedTimeChange('end', e.target.value)}
//                                 disabled={isShiftActive}
//                             />
//                         </div>

//                         {/* Actual Start Time */}
//                         <div>
//                             <label className="block text-sm font-medium text-white/90 mb-2">
//                                 Actual Start Time
//                             </label>
//                             <input
//                                 type="text"
//                                 className="w-full px-4 py-2.5 rounded-lg border-2 border-white/30 bg-white/70 text-sm text-gray-700 cursor-not-allowed"
//                                 readOnly
//                                 value={getActualStartTimeDisplay()}
//                             />
//                         </div>
//                     </div>

//                     <button
//                         className={`w-full sm:w-auto px-8 py-3 rounded-lg font-semibold transition-all transform hover:scale-105 active:scale-95 shadow-lg ${
//                             isShiftActive
//                                 ? 'bg-white text-red-600 hover:bg-red-50'
//                                 : 'bg-white text-green-600 hover:bg-green-50'
//                         }`}
//                         onClick={isShiftActive ? handleEndShift : handleStartShift}
//                     >
//                         {isShiftActive ? 'End Shift' : 'Start Shift'}
//                     </button>
//                 </div>

//                 {/* Make Sale Button */}
//                 <button
//                     className={`w-full mb-6 px-6 py-4 rounded-xl font-bold text-lg transition-all transform shadow-lg ${
//                         isShiftActive
//                             ? 'text-white hover:scale-[1.02] active:scale-95'
//                             : 'bg-gray-400 text-white cursor-not-allowed'
//                     }`}
//                     style={isShiftActive ? { background: 'linear-gradient(135deg, #0613cc, #0613cc)' } : {}}
//                     onClick={handleMakeSale}
//                     disabled={!isShiftActive}
//                 >
//                     {isShiftActive ? (
//                         <span className="flex items-center justify-center gap-3">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
//               </svg>
//               Make New Sale
//             </span>
//                     ) : (
//                         <span className="flex items-center justify-center gap-3">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//               </svg>
//               Start your Shift First!
//             </span>
//                     )}
//                 </button>

//                 {/* Today's Progress Card */}
//                 <div
//                     className="rounded-2xl shadow-lg p-5 sm:p-6"
//                     style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                 >
//                     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
//                         <h3 className="text-lg font-semibold text-white flex items-center gap-2">
//                             <svg className="w-5 h-5 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                             </svg>
//                             {selectedDate.toDateString() === new Date().toDateString()
//                                 ? "Today's Progress"
//                                 : `Progress for ${selectedDate.toLocaleDateString()}`}
//                         </h3>

//                         <div className="flex items-center gap-2">
//                             <input
//                                 type="date"
//                                 value={selectedDate.toISOString().split('T')[0]}
//                                 onChange={handleDateChange}
//                                 className="px-3 py-2 rounded-lg border-2 border-white/30 bg-white/95 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white disabled:opacity-60"
//                                 disabled={dateFilterLoading || !isShiftActive}
//                             />
//                             <button
//                                 onClick={handleTodayClick}
//                                 className="px-4 py-2 rounded-lg bg-white text-[#1565ff] text-sm font-medium hover:bg-white/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//                                 disabled={dateFilterLoading}
//                             >
//                                 Today
//                             </button>
//                         </div>
//                     </div>

//                     {dateFilterLoading ? (
//                         <div className="flex items-center justify-center py-12">
//                             <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white"></div>
//                         </div>
//                     ) : (
//                         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//                             {/* Total Sales */}
//                             <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 border border-blue-200">
//                                 <div className="text-sm font-medium text-blue-700 mb-2">Total Sales</div>
//                                 <div className="text-2xl font-bold text-blue-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(
//                                         ((parseFloat(salesData.totals?.ALL?.totalAmount || 0) -
//                                                 parseFloat(salesData.totals?.COLLECTION?.totalAmount || 0)) +
//                                             parseFloat(salesData.creditsSummary?.totalAmount || 0)
//                                         ).toString()
//                                     )}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-blue-600">
//                                         {salesData.totals?.ALL?.count - 2 || 0} cash + {salesData.totals?.CHEQUE?.count || 0} cheque + {salesData.creditsSummary?.totalCredits || 0} credit
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Total Sales Without Credits */}
//                             <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-5 border border-purple-200">
//                                 <div className="text-sm font-medium text-purple-700 mb-2">Sales (No Credit)</div>
//                                 <div className="text-2xl font-bold text-purple-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(
//                                         (parseFloat(salesData.totals?.ALL?.totalAmount || 0) -
//                                             parseFloat(salesData.totals?.COLLECTION?.totalAmount || 0)
//                                         ).toString()
//                                     )}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-purple-600">
//                                         {salesData.totals?.ALL?.count || 0} transactions
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Cash Collected */}
//                             <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-5 border border-green-200">
//                                 <div className="text-sm font-medium text-green-700 mb-2">Cash Collected</div>
//                                 <div className="text-2xl font-bold text-green-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CASH?.totalAmount || 0)}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-green-600">
//                                         {salesData.totals?.CASH?.count || 0} cash transactions
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Cheque Sales */}
//                             <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-5 border border-yellow-200">
//                                 <div className="text-sm font-medium text-yellow-700 mb-2">Cheque Sales</div>
//                                 <div className="text-2xl font-bold text-yellow-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CHEQUE?.totalAmount || 0)}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-yellow-600">
//                                         {salesData.totals?.CHEQUE?.count || 0} cheque transactions
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Credit Sales */}
//                             <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-5 border border-orange-200">
//                                 <div className="text-sm font-medium text-orange-700 mb-2">Credit Sales</div>
//                                 <div className="text-2xl font-bold text-orange-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.creditsSummary?.totalAmount || 0)}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-orange-600">
//                                         {salesData.creditsSummary?.totalCredits || 0} credit accounts
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Collections */}
//                             <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-5 border border-teal-200">
//                                 <div className="text-sm font-medium text-teal-700 mb-2">Total Collections</div>
//                                 <div className="text-2xl font-bold text-teal-900 mb-1">
//                                     {salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.COLLECTION?.totalAmount || 0)}` : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-teal-600">
//                                         {salesData.totals?.COLLECTION?.count || 0} collections
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Total Invoices */}
//                             <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-5 border border-indigo-200">
//                                 <div className="text-sm font-medium text-indigo-700 mb-2">Total Invoices</div>
//                                 <div className="text-2xl font-bold text-indigo-900 mb-1">
//                                     {salesData ? salesData.totals?.ALL?.count || 0 : 'Coming Soon'}
//                                 </div>
//                                 {salesData && (
//                                     <div className="text-xs text-indigo-600">
//                                         All transaction types
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </main>
//         </div>
//     );
// };

// export default Dashboard;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import routeService from '../../services/routeService';
import inventoryService from '../../services/inventoryService';
import ShiftService from '../../services/shiftService';
import ToastService from '../../services/toastService';
import DashboardService from '../../services/dashboardService';
import Sidebar from '../Sidebar/Sidebar';
import { BUSINESS_NAME } from '../../utils/config';

/* ═══════════════════════════════════════════════
   CSS — Clean SaaS, no gradients, Outfit + Lora
═══════════════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Lora:wght@600;700&display=swap');

*, *::before, *::after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  margin: 0; padding: 0;
}

:root {
  /* Brand */
  --p:        #0613cc;
  --p-dk:     #0613cc;
  --p-lt:     #0613cc;
  --p-xl:     #0613cc;
  --p-xxl:    #edf9f5;
  --p-hover:  #f0faf7;

  /* Ink */
  --ink:      #0b1d17;
  --ink2:     #1e4037;
  --ink3:     #4f7a6d;
  --ink4:     #8fb8ae;
  --ink5:     #c2dcd7;

  /* Surface */
  --bg:       #f4f9f7;
  --surface:  #ffffff;
  --surface2: #f8fcfa;
  --border:   #d0e8e0;
  --border2:  #e4f2ed;

  /* Status */
  --red:      #ef4444;
  --red-bg:   #fff1f1;
  --red-bdr:  #fecaca;

  /* Shadows */
  --sh-xs:  0 1px 3px rgba(11,29,23,0.06), 0 1px 2px rgba(11,29,23,0.04);
  --sh-sm:  0 2px 8px rgba(11,29,23,0.07), 0 1px 3px rgba(11,29,23,0.04);
  --sh-md:  0 4px 16px rgba(11,29,23,0.08), 0 2px 6px rgba(11,29,23,0.04);
  --sh-lg:  0 8px 32px rgba(11,29,23,0.09), 0 2px 8px rgba(11,29,23,0.04);

  /* Radius */
  --r-s:  8px;
  --r-m:  12px;
  --r-l:  16px;
  --r-xl: 20px;
}

html, body {
  height: 100%;
  font-family: 'Outfit', sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--bg);
}

/* ══════════════════════════
   ROOT
══════════════════════════ */
.db {
  min-height: 100dvh;
  min-height: 100vh;
  width: 100%;
  background: var(--bg);
  overflow-x: hidden;
}

/* ══════════════════════════
   SIDEBAR OVERLAY
══════════════════════════ */
.db-overlay {
  position: fixed; inset: 0;
  background: rgba(11,29,23,0.45);
  backdrop-filter: blur(4px);
  z-index: 40;
  animation: dbFade 0.2s ease;
}
@keyframes dbFade { from { opacity:0; } to { opacity:1; } }

/* ══════════════════════════
   HEADER — solid, no gradient
══════════════════════════ */
.db-header {
  position: sticky; top: 0; z-index: 50;
  background: var(--p-dk);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 1px 0 rgba(255,255,255,0.06), var(--sh-sm);
}
.db-header-inner {
  display: flex; align-items: center;
  justify-content: space-between;
  height: 56px; padding: 0 16px;
  max-width: 1280px; margin: 0 auto;
}
.db-menu-btn {
  width: 38px; height: 38px; border-radius: var(--r-s);
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.15);
  color: white; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
  flex-shrink: 0;
}
.db-menu-btn:hover { background: rgba(255,255,255,0.18); }

.db-header-brand {
  display: flex; align-items: center; gap: 10px;
}
.db-header-logo {
  width: 30px; height: 30px; border-radius: 8px;
  background: rgba(255,255,255,0.14);
  border: 1px solid rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.db-header-title {
  font-family: 'Lora', serif;
  font-size: 16px; font-weight: 700;
  color: #fff; letter-spacing: -0.2px;
}

.db-shift-pill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 11px; border-radius: 40px;
  font-size: 12px; font-weight: 700;
  letter-spacing: 0.2px;
  transition: all 0.25s;
}
.db-shift-pill.on {
  background: rgba(34,196,151,0.15);
  border: 1.5px solid rgba(34,196,151,0.35);
  color: #22c497;
}
.db-shift-pill.off {
  background: rgba(255,255,255,0.08);
  border: 1.5px solid rgba(255,255,255,0.15);
  color: rgba(255,255,255,0.55);
}
.db-shift-dot {
  width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;
}
.db-shift-pill.on  .db-shift-dot { background: #22c497; animation: dbDotPulse 2s ease-in-out infinite; }
.db-shift-pill.off .db-shift-dot { background: rgba(255,255,255,0.35); }
@keyframes dbDotPulse {
  0%,100% { box-shadow: 0 0 0 2px rgba(34,196,151,0.2); }
  50%      { box-shadow: 0 0 0 5px rgba(34,196,151,0.05); }
}

/* ══════════════════════════
   MAIN LAYOUT
══════════════════════════ */
.db-main {
  padding: 20px 16px 48px;
  max-width: 1280px; margin: 0 auto;
}

/* Staggered entrance */
.db-section {
  opacity: 0; transform: translateY(14px);
  animation: dbUp 0.38s cubic-bezier(.22,.68,0,1.16) forwards;
}
.db-section:nth-child(1) { animation-delay: 0.04s; }
.db-section:nth-child(2) { animation-delay: 0.08s; }
.db-section:nth-child(3) { animation-delay: 0.12s; }
.db-section:nth-child(4) { animation-delay: 0.16s; }
.db-section:nth-child(5) { animation-delay: 0.20s; }
@keyframes dbUp { to { opacity:1; transform:translateY(0); } }

/* ══════════════════════════
   GREETING
══════════════════════════ */
.db-greeting { margin-bottom: 22px; }
.db-greeting-name {
  font-family: 'Lora', serif;
  font-size: clamp(20px, 5.5vw, 28px);
  font-weight: 700; color: var(--ink);
  letter-spacing: -0.4px; margin-bottom: 4px;
  line-height: 1.2;
}
.db-greeting-date {
  font-size: 13px; color: var(--ink3); font-weight: 400;
}

/* ══════════════════════════
   CARD — base SaaS card
══════════════════════════ */
.db-card {
  background: var(--surface);
  border-radius: var(--r-xl);
  border: 1px solid var(--border);
  box-shadow: var(--sh-sm);
  margin-bottom: 16px;
  overflow: hidden;
}

/* Card header — solid teal, no gradient */
.db-card-hd {
  background: var(--p);
  padding: 14px 18px;
  display: flex; align-items: center; gap: 10px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.db-card-hd-icon {
  width: 32px; height: 32px; border-radius: 8px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.db-card-hd-title {
  font-family: 'Lora', serif;
  font-size: 14.5px; font-weight: 700;
  color: #fff; letter-spacing: -0.15px;
  flex: 1;
}
.db-card-hd-badge {
  font-size: 11.5px; font-weight: 700;
  color: rgba(255,255,255,0.82);
  background: rgba(255,255,255,0.14);
  border: 1px solid rgba(255,255,255,0.18);
  padding: 3px 10px; border-radius: 20px;
  flex-shrink: 0;
}
.db-card-body { padding: 16px; }

/* ══════════════════════════
   METRIC TILES
══════════════════════════ */
.db-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.db-tile {
  background: var(--surface);
  border-radius: var(--r-l);
  border: 1px solid var(--border);
  padding: 14px 13px;
  box-shadow: var(--sh-xs);
  transition: box-shadow 0.18s, transform 0.15s;
  position: relative;
  overflow: hidden;
}
.db-tile:active { transform: scale(0.98); }

/* Left accent bar — replaces gradient */
.db-tile::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  border-radius: 3px 0 0 3px;
}

/* Tile colour variants — flat, no gradient */
.db-t-blue   { border-color: #bfdbfe; background: #f0f6ff; } .db-t-blue::before   { background: #3b82f6; }
.db-t-purple { border-color: #ddd6fe; background: #f5f3ff; } .db-t-purple::before { background: #7c3aed; }
.db-t-green  { border-color: #bbf7d0; background: #f0fdf4; } .db-t-green::before  { background: #16a34a; }
.db-t-yellow { border-color: #fde68a; background: #fefce8; } .db-t-yellow::before { background: #ca8a04; }
.db-t-orange { border-color: #fed7aa; background: #fff7ed; } .db-t-orange::before { background: #ea580c; }
.db-t-teal   { border-color: #99f6e4; background: #f0fdfa; } .db-t-teal::before   { background: #0d9488; }
.db-t-indigo { border-color: #c7d2fe; background: #eef2ff; } .db-t-indigo::before { background: #4338ca; }

.db-tile-lbl {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.55px;
  margin-bottom: 7px;
}
.db-t-blue   .db-tile-lbl { color: #2563eb; }
.db-t-purple .db-tile-lbl { color: #6d28d9; }
.db-t-green  .db-tile-lbl { color: #15803d; }
.db-t-yellow .db-tile-lbl { color: #a16207; }
.db-t-orange .db-tile-lbl { color: #c2410c; }
.db-t-teal   .db-tile-lbl { color: #0f766e; }
.db-t-indigo .db-tile-lbl { color: #4338ca; }

.db-tile-val {
  font-family: 'Lora', serif;
  font-size: clamp(14px, 3.8vw, 17px);
  font-weight: 700; line-height: 1.2;
  letter-spacing: -0.3px;
}
.db-t-blue   .db-tile-val { color: #1e3a8a; }
.db-t-purple .db-tile-val { color: #3b0764; }
.db-t-green  .db-tile-val { color: #14532d; }
.db-t-yellow .db-tile-val { color: #713f12; }
.db-t-orange .db-tile-val { color: #7c2d12; }
.db-t-teal   .db-tile-val { color: #134e4a; }
.db-t-indigo .db-tile-val { color: #1e1b4b; }

.db-tile-sub {
  font-size: 10.5px; font-weight: 500; margin-top: 5px;
}
.db-t-blue   .db-tile-sub { color: #3b82f6; }
.db-t-purple .db-tile-sub { color: #7c3aed; }
.db-t-green  .db-tile-sub { color: #16a34a; }
.db-t-yellow .db-tile-sub { color: #ca8a04; }
.db-t-orange .db-tile-sub { color: #ea580c; }
.db-t-teal   .db-tile-sub { color: #0d9488; }
.db-t-indigo .db-tile-sub { color: #4338ca; }

/* ══════════════════════════
   FORM ELEMENTS
══════════════════════════ */
.db-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.db-field-lbl {
  display: block;
  font-size: 11.5px; font-weight: 700;
  color: var(--ink2);
  text-transform: uppercase; letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.db-select,
.db-input-t,
.db-input-ro {
  width: 100%; min-height: 46px;
  padding: 11px 14px;
  border-radius: var(--r-s);
  border: 1.5px solid var(--border);
  background: var(--surface2);
  font-size: 14px; font-family: 'Outfit', sans-serif;
  color: var(--ink); font-weight: 500;
  outline: none;
  -webkit-appearance: none; appearance: none;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.db-select:focus,
.db-input-t:focus {
  border-color: var(--p);
  background: var(--surface);
  box-shadow: 0 0 0 3px rgba(26,138,110,0.11);
}
.db-select:disabled,
.db-input-t:disabled { opacity: 0.48; cursor: not-allowed; }
.db-input-ro {
  background: var(--p-xxl); color: var(--ink3);
  cursor: not-allowed; opacity: 0.85;
}

/* Select arrow */
.db-select-wrap { position: relative; }
.db-select-wrap::after {
  content: '';
  position: absolute; right: 14px; top: 50%;
  transform: translateY(-50%);
  width: 0; height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid var(--ink3);
  pointer-events: none;
}

/* ══════════════════════════
   SHIFT BUTTONS
══════════════════════════ */
.db-shift-btn {
  width: 100%; min-height: 48px;
  padding: 12px 20px; border-radius: var(--r-m);
  border: none; cursor: pointer;
  font-size: 14.5px; font-weight: 700;
  font-family: 'Outfit', sans-serif;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  transition: opacity 0.18s, transform 0.15s, box-shadow 0.18s;
  letter-spacing: 0.1px;
}
.db-shift-btn.start {
  background: var(--p);
  color: #fff;
  box-shadow: 0 2px 10px rgba(26,138,110,0.28);
}
.db-shift-btn.start:hover { background: var(--p-dk); box-shadow: 0 4px 16px rgba(26,138,110,0.34); transform: translateY(-1px); }
.db-shift-btn.start:active { transform: scale(0.98); opacity: 0.92; }

.db-shift-btn.end {
  background: var(--red);
  color: #fff;
  box-shadow: 0 2px 10px rgba(239,68,68,0.24);
}
.db-shift-btn.end:hover { background: #dc2626; box-shadow: 0 4px 16px rgba(239,68,68,0.30); transform: translateY(-1px); }
.db-shift-btn.end:active { transform: scale(0.98); opacity: 0.92; }

/* ══════════════════════════
   MAKE SALE BUTTON
══════════════════════════ */
.db-sale-btn {
  width: 100%; min-height: 54px;
  padding: 14px 20px; border-radius: var(--r-l);
  border: none; cursor: pointer;
  font-size: clamp(14px, 4vw, 16px); font-weight: 800;
  font-family: 'Outfit', sans-serif;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  transition: opacity 0.18s, transform 0.15s, box-shadow 0.18s;
  letter-spacing: 0.15px;
  margin-bottom: 16px;
}
.db-sale-btn.active {
  background: var(--p);
  color: #fff;
  box-shadow: 0 4px 20px rgba(26,138,110,0.30);
}
.db-sale-btn.active:hover {
  background: var(--p-dk);
  box-shadow: 0 6px 26px rgba(26,138,110,0.38);
  transform: translateY(-1px);
}
.db-sale-btn.active:active { transform: scale(0.98); }
.db-sale-btn.inactive {
  background: #9ca3af;
  color: #fff; cursor: not-allowed; opacity: 0.65;
}

/* ══════════════════════════
   DATE ROW
══════════════════════════ */
.db-date-row {
  display: flex; align-items: center; gap: 8px;
  flex-wrap: wrap; margin-bottom: 14px;
}
.db-date-input {
  flex: 1; min-width: 0; min-height: 40px;
  padding: 9px 12px;
  border-radius: var(--r-s);
  border: 1.5px solid var(--border);
  background: var(--surface2);
  font-size: 13.5px; font-family: 'Outfit', sans-serif;
  color: var(--ink); font-weight: 500;
  outline: none;
  -webkit-appearance: none; appearance: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.db-date-input:focus { border-color: var(--p); box-shadow: 0 0 0 3px rgba(26,138,110,0.11); }
.db-date-input:disabled { opacity: 0.48; cursor: not-allowed; }

.db-today-btn {
  min-height: 40px; padding: 9px 16px;
  border-radius: var(--r-s); border: none;
  background: var(--p);
  color: #fff; font-size: 13px; font-weight: 700;
  font-family: 'Outfit', sans-serif; cursor: pointer;
  white-space: nowrap; flex-shrink: 0;
  box-shadow: 0 1px 6px rgba(26,138,110,0.22);
  transition: background 0.15s, transform 0.12s, box-shadow 0.15s;
}
.db-today-btn:hover { background: var(--p-dk); transform: translateY(-1px); }
.db-today-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

/* ══════════════════════════
   SPINNER
══════════════════════════ */
.db-spinner {
  display: flex; justify-content: center; align-items: center;
  padding: 32px 0;
}
.db-spin {
  width: 32px; height: 32px;
  border: 3px solid var(--p-xl);
  border-top-color: var(--p);
  border-radius: 50%;
  animation: dbSpin 0.75s linear infinite;
}
@keyframes dbSpin { to { transform: rotate(360deg); } }

/* ══════════════════════════
   DIVIDER
══════════════════════════ */
.db-divider {
  height: 1px; background: var(--border2);
  margin: 14px 0;
}

/* ══════════════════════════
   TOASTS
══════════════════════════ */
.toast-container {
  position: fixed; z-index: 9999;
  display: flex; flex-direction: column; gap: 9px;
  bottom: 18px; left: 50%; transform: translateX(-50%);
  width: calc(100% - 28px); max-width: 380px;
}
.toast {
  background: var(--surface); color: var(--ink);
  padding: 13px 16px; border-radius: var(--r-m);
  box-shadow: var(--sh-lg);
  opacity: 0; visibility: hidden;
  transform: translateY(12px) scale(0.96);
  transition: opacity .26s, transform .26s cubic-bezier(.22,.68,0,1.2), visibility .26s;
  font-size: 14px; font-weight: 600;
  font-family: 'Outfit', sans-serif;
  border-left: 4px solid transparent;
}
.toast.show { opacity:1; visibility:visible; transform:translateY(0) scale(1); }
.toast.error   { border-left-color: #ef4444; }
.toast.info    { border-left-color: var(--p); }
.toast.success { border-left-color: var(--p-lt); }
.toast.warning { border-left-color: #f59e0b; }

/* ══════════════════════════════════════
   BREAKPOINTS — mobile-first
══════════════════════════════════════ */

/* Tiny ≤ 360px */
@media (max-width: 360px) {
  .db-main        { padding: 16px 12px 40px; }
  .db-grid        { gap: 8px; }
  .db-tile        { padding: 12px 10px; }
  .db-card-body   { padding: 14px 13px; }
  .db-sale-btn    { min-height: 50px; }
}

/* Phablet ≥ 430px */
@media (min-width: 430px) {
  .db-main        { padding: 22px 20px 44px; }
  .db-grid        { gap: 12px; }
}

/* Small tablet ≥ 600px */
@media (min-width: 600px) {
  .db-header-inner { padding: 0 24px; height: 60px; }
  .db-main         { padding: 24px 28px 48px; }
  .db-grid         { grid-template-columns: repeat(3, 1fr); }
  .db-form-grid    { grid-template-columns: repeat(2, 1fr); }
  .db-card-body    { padding: 18px 20px 20px; }
  .db-card-hd      { padding: 15px 20px; }
  .toast-container { bottom: auto; top: 20px; left: auto; right: 20px; transform: none; width: auto; max-width: 360px; }
  .toast           { transform: translateX(12px) scale(0.96); }
  .toast.show      { transform: translateX(0) scale(1); }
}

/* Tablet ≥ 768px */
@media (min-width: 768px) {
  .db-header-inner { padding: 0 32px; }
  .db-header-title { font-size: 17px; }
  .db-main         { padding: 28px 36px 52px; }
  .db-grid         { gap: 14px; }
  .db-form-grid    { grid-template-columns: repeat(3, 1fr); }
  .db-sale-btn     { min-height: 56px; font-size: 16px; }
}

/* Desktop ≥ 1024px */
@media (min-width: 1024px) {
  .db-header-inner  { padding: 0 40px; height: 62px; }
  .db-main          { padding: 32px 44px 56px; }
  .db-grid          { grid-template-columns: repeat(6, 1fr); }
  .db-grid.four     { grid-template-columns: repeat(4, 1fr); }
  .db-grid.seven    { grid-template-columns: repeat(4, 1fr); }
  .db-menu-btn      { display: none; }
  .db-greeting-name { font-size: 28px; }
  .db-form-grid     { grid-template-columns: repeat(3, 1fr); }
}

/* Large ≥ 1280px */
@media (min-width: 1280px) {
  .db-main       { padding: 36px 52px 60px; }
  .db-grid.seven { grid-template-columns: repeat(7, 1fr); }
}
`;

/* ─── Mock data (unchanged) ─── */
const MOCK_ROUTES         = [{ id:'1', name:'Coming Soon' }];
const MOCK_INVENTORIES    = [{ id:'1', name:'Coming Soon' }];
const MOCK_MONTHLY_TARGET = { currentSales:0, targetAmount:0 };
const MOCK_TODAY_PROGRESS = { totalSales:0, cashCollected:0, creditSales:0, totalCollections:0, totalInvoices:0, visitsMade:0, totalCustomers:0 };
const MOCK_SHIFT_DATA     = [{ date:'Coming Soon', route:'Coming Soon', sales:0, collections:0, status:'Pending' }];

/* ─── Tiny icon helper ─── */
const Ic = ({ path, size=18, color='currentColor', fill='none', sw=2, extra=null }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
    {Array.isArray(path) ? path.map((d,i)=><path key={i} d={d}/>) : <path d={path}/>}
    {extra}
  </svg>
);

/* ─── Icon set ─── */
const IcMenu  = () => <Ic size={20} color="white" path="M4 6h16M4 12h16M4 18h16"/>;
const IcUsers = () => <Ic size={15} color="white" path={["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2","M23 21v-2a4 4 0 0 0-3-3.87","M16 3.13a4 4 0 0 1 0 7.75"]}/>;
const IcChart = () => <Ic size={15} color="white" path="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>;
const IcClock = () => <Ic size={15} color="white" path={["M12 8v4l3 3","M21 12a9 9 0 11-18 0 9 9 0 0118 0"]}/>;
const IcBar   = () => <Ic size={15} color="white" path="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>;
const IcCart  = () => <Ic size={20} color="white" path="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>;
const IcLock  = () => <Ic size={20} color="white" path={["M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"]}/>;
const IcPlay  = () => <Ic size={16} color="white" fill="white" path="M5 3l14 9-14 9V3z"/>;
const IcStop  = () => <Ic size={16} color="white" fill="white" path="M18 6H6v12h12z"/>;

/* ═══════════════════════════════════════════════
   COMPONENT
═══════════════════════════════════════════════ */
const Dashboard = () => {
  const navigate = useNavigate();

  /* — state (identical to original) — */
  const [user,              setUser]              = useState(null);
  const [routes,            setRoutes]            = useState([]);
  const [inventories,       setInventories]       = useState([]);
  const [selectedRoute,     setSelectedRoute]     = useState('');
  const [selectedInventory, setSelectedInventory] = useState('');
  const [plannedStartTime,  setPlannedStartTime]  = useState('08:00');
  const [plannedEndTime,    setPlannedEndTime]     = useState('17:00');
  const [isShiftActive,     setIsShiftActive]     = useState(false);
  const [shiftStartTime,    setShiftStartTime]    = useState(null);
  const [showSidebar,       setShowSidebar]       = useState(false);
  const [loading,           setLoading]           = useState({ routes:false, inventories:false });
  const [shiftData,         setShiftData]         = useState([]);
  const [monthlyTarget,     setMonthlyTarget]     = useState(MOCK_MONTHLY_TARGET);
  const [todayProgress,     setTodayProgress]     = useState(MOCK_TODAY_PROGRESS);
  const [salesData,         setSalesData]         = useState(null);
  const [widgetSalesData,   setWidgetSalesData]   = useState(null);
  const [selectedDate,      setSelectedDate]      = useState(new Date());
  const [dateFilterLoading, setDateFilterLoading] = useState(false);

  /* Inject CSS once */
  useEffect(() => {
    if (!document.getElementById('db-css')) {
      const s = document.createElement('style');
      s.id = 'db-css'; s.textContent = CSS;
      document.head.appendChild(s);
    }
  }, []);

  /* — all original logic unchanged — */
  useEffect(() => {
    if (!authService.isAuthenticated()) {
      ToastService.error('Session expired. Please login again.');
      navigate('/login'); return;
    }
    const u = authService.getCurrentUser(); setUser(u);
    ShiftService.initializeShift();
    const active = ShiftService.isShiftActive(); setIsShiftActive(active);
    if (active) {
      const shift = ShiftService.getCurrentShift();
      setSelectedRoute(shift.routeId?.toString() || '');
      setSelectedInventory(shift.inventoryId?.toString() || '');
      setShiftStartTime(shift.startTime);
      const ps = JSON.parse(localStorage.getItem('plannedShift')) || { start:'08:00', end:'17:00' };
      setPlannedStartTime(ps.start); setPlannedEndTime(ps.end);
    }
    fetchData(); fetchWidgetSalesData(); fetchSalesData(); loadShiftData();
  }, [navigate]);

  const fetchWidgetSalesData = async () => {
    try {
      const data = await DashboardService.getSalesDataMonthToDate();
      setWidgetSalesData(data);
    } catch {
      setWidgetSalesData({ totals:{ CASH:{totalAmount:'0',count:0}, CHEQUE:{totalAmount:'0',count:0}, COLLECTION:{totalAmount:0,count:0}, ALL:{totalAmount:'0',count:0} }, creditsSummary:{totalAmount:0,totalCredits:0} });
    }
  };

  const fetchData = async () => {
    try {
      setLoading(p=>({...p,routes:true}));
      try { const r = await routeService.getAvailableRoutes(); setRoutes(r.success ? r.data.map(x=>({id:x.id.toString(),name:x.name})) : MOCK_ROUTES); } catch { setRoutes(MOCK_ROUTES); }
      setLoading(p=>({...p,inventories:true}));
      try { const r = await inventoryService.getAvailableInventories(); setInventories(r.success ? r.data.map(x=>({id:x.id.toString(),name:x.name})) : MOCK_INVENTORIES); } catch { setInventories(MOCK_INVENTORIES); }
    } catch { ToastService.error('Failed to load dashboard data'); }
    finally { setLoading({routes:false,inventories:false}); }
  };

  const fetchSalesData = async (date = new Date()) => {
    try {
      setDateFilterLoading(true);
      const data = await DashboardService.getSalesData(date); setSalesData(data);
    } catch { ToastService.error('Failed to load sales data'); }
    finally { setDateFilterLoading(false); }
  };

  const loadShiftData = () => { setShiftData(MOCK_SHIFT_DATA); setMonthlyTarget(MOCK_MONTHLY_TARGET); setTodayProgress(MOCK_TODAY_PROGRESS); };

  const handleStartShift = () => {
    if (!selectedRoute || !selectedInventory) { ToastService.error('Please select both Lorry/Route and Warehouse/Area first!','error',3000); return; }
    const shift = ShiftService.startShift(selectedRoute, selectedInventory);
    setIsShiftActive(true); setShiftStartTime(shift.startTime);
    localStorage.setItem('plannedShift', JSON.stringify({start:plannedStartTime,end:plannedEndTime}));
    ToastService.success(`Shift Started! ${getCurrentRouteName()}`,'success',3500);
  };

  const handleEndShift = () => {
    if (window.confirm('End your shift now?')) {
      const ms = new Date() - new Date(shiftStartTime);
      const h = Math.floor(ms/3600000), m = Math.floor((ms%3600000)/60000);
      ShiftService.endShift();
      setIsShiftActive(false); setSelectedRoute(''); setSelectedInventory(''); setShiftStartTime(null);
      ToastService.success(`Shift Ended! ${h}h ${m}m`,'info',3000);
      loadShiftData();
    }
  };

  const handleMakeSale = () => {
    if (!isShiftActive) { ToastService.error('Please start your shift first!','error',3000); return; }
    navigate('/create-sale');
  };

  const handlePlannedTimeChange = (type, value) => {
    if (!isShiftActive) {
      if (type==='start') setPlannedStartTime(value); else setPlannedEndTime(value);
      localStorage.setItem('plannedShift', JSON.stringify({start:type==='start'?value:plannedStartTime, end:type==='end'?value:plannedEndTime}));
      ToastService.success('Planned shift time saved','success',2000);
    }
  };

  const getCurrentRouteName     = () => routes.find(r=>r.id===selectedRoute)?.name || 'Not selected';
  const getCurrentInventoryName = () => inventories.find(i=>i.id===selectedInventory)?.name || 'Not selected';

  const getGreeting = () => { const h=new Date().getHours(); return h<12?'Good Morning':h<18?'Good Afternoon':'Good Evening'; };
  const formatDate  = () => new Date().toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'});

  const getShiftDuration = () => {
    if (!shiftStartTime) return '0m';
    const ms = new Date() - new Date(shiftStartTime);
    const h=Math.floor(ms/3600000), m=Math.floor((ms%3600000)/60000);
    return h>0?`${h}h ${m}m`:`${m}m`;
  };

  const getActualStartTimeDisplay = () => {
    if (!shiftStartTime) return 'Not Started';
    return `Started: ${new Date(shiftStartTime).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}`;
  };

  const handleRouteChange = e => {
    const v=e.target.value; setSelectedRoute(v);
    if (v && !isShiftActive) ToastService.info(`Route: ${routes.find(r=>r.id===v)?.name}`,'info',2000);
  };

  const handleInventoryChange = e => {
    const v=e.target.value; setSelectedInventory(v);
    if (v && !isShiftActive) ToastService.info(`Area: ${inventories.find(i=>i.id===v)?.name}`,'info',2000);
  };

  const handleDateChange = e => { const d=new Date(e.target.value); setSelectedDate(d); fetchSalesData(d); };
  const handleTodayClick = () => { const d=new Date(); setSelectedDate(d); fetchSalesData(d); };

  /* — computed values — */
  const wTotal    = widgetSalesData ? ((parseFloat(widgetSalesData.totals?.ALL?.totalAmount||0)-parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount||0))+parseFloat(widgetSalesData.creditsSummary?.totalAmount||0)).toString() : '0';
  const wNoCredit = widgetSalesData ? (parseFloat(widgetSalesData.totals?.ALL?.totalAmount||0)-parseFloat(widgetSalesData.totals?.COLLECTION?.totalAmount||0)).toString() : '0';
  const fmtW      = v => widgetSalesData ? `Rs. ${DashboardService.formatCurrency(v)}` : '—';
  const sTotal    = salesData ? ((parseFloat(salesData.totals?.ALL?.totalAmount||0)-parseFloat(salesData.totals?.COLLECTION?.totalAmount||0))+parseFloat(salesData.creditsSummary?.totalAmount||0)).toString() : null;
  const sNoCredit = salesData ? (parseFloat(salesData.totals?.ALL?.totalAmount||0)-parseFloat(salesData.totals?.COLLECTION?.totalAmount||0)).toString() : null;
  const fmtS      = v => salesData ? `Rs. ${DashboardService.formatCurrency(v)}` : 'Coming Soon';

  /* ══════════════════════════
     RENDER
  ══════════════════════════ */
  return (
    <div className="db">
      <div id="toastContainer" className="toast-container" />

      <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />
      {showSidebar && <div className="db-overlay" onClick={() => setShowSidebar(false)} />}

      {/* ── HEADER ── */}
      <header className="db-header">
        <div className="db-header-inner">
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <button className="db-menu-btn" onClick={() => setShowSidebar(true)} aria-label="Menu">
              <IcMenu />
            </button>
            <div className="db-header-brand">
              <span className="db-header-title">{BUSINESS_NAME}</span>
            </div>
          </div>
          <div className={`db-shift-pill ${isShiftActive?'on':'off'}`}>
            <div className="db-shift-dot" />
            Shift: {isShiftActive ? 'ON' : 'OFF'}
          </div>
        </div>
      </header>

      {/* ── MAIN ── */}
      <main className="db-main">

        {/* GREETING */}
        <div className="db-section db-greeting">
          <div className="db-greeting-name">{getGreeting()}, {user?.firstName || 'User'}!</div>
          <div className="db-greeting-date">{formatDate()}</div>
        </div>

        {/* ─── SALES OVERVIEW MTD ─── */}
        <div className="db-section db-card">
          <div className="db-card-hd">
            <div className="db-card-hd-icon"><IcChart /></div>
            <span className="db-card-hd-title">Sales Overview — Month to Date</span>
          </div>
          <div className="db-card-body">
            <div className="db-grid">
              <div className="db-tile db-t-blue">
                <div className="db-tile-lbl">Total Sales</div>
                <div className="db-tile-val">{fmtW(wTotal)}</div>
              </div>
              <div className="db-tile db-t-purple">
                <div className="db-tile-lbl">Sales (No Credit)</div>
                <div className="db-tile-val">{fmtW(wNoCredit)}</div>
              </div>
              <div className="db-tile db-t-green">
                <div className="db-tile-lbl">Cash</div>
                <div className="db-tile-val">{fmtW(widgetSalesData?.totals?.CASH?.totalAmount||0)}</div>
              </div>
              <div className="db-tile db-t-yellow">
                <div className="db-tile-lbl">Cheque</div>
                <div className="db-tile-val">{fmtW(widgetSalesData?.totals?.CHEQUE?.totalAmount||0)}</div>
              </div>
              <div className="db-tile db-t-orange">
                <div className="db-tile-lbl">Credit</div>
                <div className="db-tile-val">{fmtW(widgetSalesData?.creditsSummary?.totalAmount||0)}</div>
              </div>
              <div className="db-tile db-t-teal">
                <div className="db-tile-lbl">Collections</div>
                <div className="db-tile-val">{fmtW(widgetSalesData?.totals?.COLLECTION?.totalAmount||0)}</div>
              </div>
            </div>
          </div>
        </div>

        {/* ─── SHIFT MANAGEMENT ─── */}
        <div className="db-section db-card">
          <div className="db-card-hd">
            <div className="db-card-hd-icon"><IcClock /></div>
            <span className="db-card-hd-title">My Shift Today</span>
            {isShiftActive && (
              <span className="db-card-hd-badge">⏱ {getShiftDuration()}</span>
            )}
          </div>
          <div className="db-card-body">
            <div className="db-form-grid">
              <div>
                <label className="db-field-lbl">Lorry / Route</label>
                <div className="db-select-wrap">
                  <select className="db-select" value={selectedRoute} onChange={handleRouteChange} disabled={isShiftActive || loading.routes}>
                    <option value="" disabled>Select Lorry / Route</option>
                    {routes.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="db-field-lbl">Warehouse / Area</label>
                <div className="db-select-wrap">
                  <select className="db-select" value={selectedInventory} onChange={handleInventoryChange} disabled={isShiftActive || loading.inventories}>
                    <option value="" disabled>Select Warehouse / Area</option>
                    {inventories.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="db-field-lbl">Planned Start</label>
                <input type="time" className="db-input-t" value={plannedStartTime} onChange={e => handlePlannedTimeChange('start', e.target.value)} disabled={isShiftActive} />
              </div>
              <div>
                <label className="db-field-lbl">Planned End</label>
                <input type="time" className="db-input-t" value={plannedEndTime} onChange={e => handlePlannedTimeChange('end', e.target.value)} disabled={isShiftActive} />
              </div>
              <div>
                <label className="db-field-lbl">Actual Start</label>
                <input type="text" className="db-input-ro" readOnly value={getActualStartTimeDisplay()} />
              </div>
            </div>

            <button className={`db-shift-btn ${isShiftActive ? 'end' : 'start'}`} onClick={isShiftActive ? handleEndShift : handleStartShift}>
              {isShiftActive ? <><IcStop /> End Shift</> : <><IcPlay /> Start Shift</>}
            </button>
          </div>
        </div>

        {/* ─── MAKE SALE ─── */}
        <div className="db-section">
          <button className={`db-sale-btn ${isShiftActive ? 'active' : 'inactive'}`} onClick={handleMakeSale} disabled={!isShiftActive}>
            {isShiftActive ? <><IcCart /> Make New Sale</> : <><IcLock /> Start your Shift First!</>}
          </button>
        </div>

        {/* ─── TODAY'S PROGRESS ─── */}
        <div className="db-section db-card">
          <div className="db-card-hd">
            <div className="db-card-hd-icon"><IcBar /></div>
            <span className="db-card-hd-title">
              {selectedDate.toDateString() === new Date().toDateString()
                ? "Today's Progress"
                : `Progress — ${selectedDate.toLocaleDateString()}`}
            </span>
          </div>
          <div className="db-card-body">
            <div className="db-date-row">
              <input
                type="date"
                className="db-date-input"
                value={selectedDate.toISOString().split('T')[0]}
                onChange={handleDateChange}
                disabled={dateFilterLoading || !isShiftActive}
              />
              <button className="db-today-btn" onClick={handleTodayClick} disabled={dateFilterLoading}>
                Today
              </button>
            </div>

            {dateFilterLoading ? (
              <div className="db-spinner"><div className="db-spin" /></div>
            ) : (
              <div className="db-grid seven">
                <div className="db-tile db-t-blue">
                  <div className="db-tile-lbl">Total Sales</div>
                  <div className="db-tile-val">{sTotal ? `Rs. ${DashboardService.formatCurrency(sTotal)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{(salesData.totals?.ALL?.count-2)||0} cash + {salesData.totals?.CHEQUE?.count||0} cheque + {salesData.creditsSummary?.totalCredits||0} credit</div>}
                </div>
                <div className="db-tile db-t-purple">
                  <div className="db-tile-lbl">Sales (No Credit)</div>
                  <div className="db-tile-val">{sNoCredit ? `Rs. ${DashboardService.formatCurrency(sNoCredit)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{salesData.totals?.ALL?.count||0} transactions</div>}
                </div>
                <div className="db-tile db-t-green">
                  <div className="db-tile-lbl">Cash Collected</div>
                  <div className="db-tile-val">{salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CASH?.totalAmount||0)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{salesData.totals?.CASH?.count||0} cash transactions</div>}
                </div>
                <div className="db-tile db-t-yellow">
                  <div className="db-tile-lbl">Cheque Sales</div>
                  <div className="db-tile-val">{salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.CHEQUE?.totalAmount||0)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{salesData.totals?.CHEQUE?.count||0} cheque transactions</div>}
                </div>
                <div className="db-tile db-t-orange">
                  <div className="db-tile-lbl">Credit Sales</div>
                  <div className="db-tile-val">{salesData ? `Rs. ${DashboardService.formatCurrency(salesData.creditsSummary?.totalAmount||0)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{salesData.creditsSummary?.totalCredits||0} credit accounts</div>}
                </div>
                <div className="db-tile db-t-teal">
                  <div className="db-tile-lbl">Collections</div>
                  <div className="db-tile-val">{salesData ? `Rs. ${DashboardService.formatCurrency(salesData.totals?.COLLECTION?.totalAmount||0)}` : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">{salesData.totals?.COLLECTION?.count||0} collections</div>}
                </div>
                <div className="db-tile db-t-indigo">
                  <div className="db-tile-lbl">Total Invoices</div>
                  <div className="db-tile-val">{salesData ? (salesData.totals?.ALL?.count||0) : 'Coming Soon'}</div>
                  {salesData && <div className="db-tile-sub">All transaction types</div>}
                </div>
              </div>
            )}
          </div>
        </div>

      </main>
    </div>
  );
};

export default Dashboard;
